/**
 * Utility function to export an array of typed objects to a CSV file.
 * 
 * @param data Array of objects to export
 * @param filename Name of the file to save (without .csv)
 * @param headers Mapping of object keys to column names { "key": "Column Name" }
 */
export const exportToCSV = <T extends Record<string, any>>(
  data: T[],
  filename: string,
  headers?: Record<keyof T | string, string>
) => {
  if (!data || !data.length) {
    console.warn("No data to export.");
    return;
  }

  // Determine the columns based on headers or keys of the first item
  const keys = headers ? Object.keys(headers) : Object.keys(data[0]);
  const columnNames = headers ? Object.values(headers) : keys;

  // Build CSV content
  const rows = [
    // Header row
    columnNames.map(col => `"${col}"`).join(','),
    ...data.map(item =>
      keys
        .map(key => {
          let val = item[key];
          
          if (val === null || val === undefined) val = "";
          else if (typeof val === 'object') val = JSON.stringify(val);
          else val = String(val);
          
          // Escape quotes and wrap in quotes
          return `"${val.replace(/"/g, '""')}"`;
        })
        .join(',')
    )
  ];

  const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + rows.join('\n');
  const encodedUri = encodeURI(csvContent);

  // Trigger download
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
